import * as XLSX from "xlsx";

export const MAX_PREVIEW_ROWS = 1000;
export const MAX_PREVIEW_COLUMNS = 100;

export const readExcelPreview = (arrayBuffer) => {
  const workbook = XLSX.read(arrayBuffer, {
    type: "array",
    cellHTML: false,
    cellFormula: false,
    sheetRows: MAX_PREVIEW_ROWS + 1,
  });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) throw new Error("El Excel no contiene hojas");
  const worksheet = workbook.Sheets[sheetName];
  const reference = worksheet["!fullref"] || worksheet["!ref"];
  if (!reference) return { sheetName, rows: [], truncated: false };
  const range = XLSX.utils.decode_range(reference);
  const previewRange = {
    s: range.s,
    e: {
      r: Math.min(range.e.r, range.s.r + MAX_PREVIEW_ROWS - 1),
      c: Math.min(range.e.c, range.s.c + MAX_PREVIEW_COLUMNS - 1),
    },
  };
  const rows = XLSX.utils
    .sheet_to_json(worksheet, {
      header: 1,
      raw: false,
      defval: "",
      blankrows: true,
      range: previewRange,
    })
    .map((row) => row.map((value) => String(value ?? "")));
  return {
    sheetName,
    rows,
    truncated: range.e.r > previewRange.e.r || range.e.c > previewRange.e.c,
  };
};
